import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { BsStopwatch } from "react-icons/bs";
import { FaSwimmingPool } from "react-icons/fa";
import { TbTruckDelivery, TbCoins } from "react-icons/tb";
import { RiFileWarningLine } from 'react-icons/ri';


/**
 * InvoiceClassCard component
 * 
 * component for displaying cards of types of invoice
 * 
 * @param {select} props function to change parent state of selected type
 * @param {selected} props array of selected types
 * @param {type} props object type
 * 
 * @returns card of type
 */
const InvoiceClassCard = (props) => {

    const [hover, setHover] = useState(""); // css class state when to display hover effect
    const isSelected = props.selected.includes(props.type.id); // bool if selected props has id of this type
    const isDisabled = props.type.count === 0; // bool when type objects count is 0. there are no invoices for this type
    const bg = isSelected? '#a2c13f' : 'white'; // css class switch when is selected or not
    const textColor = isSelected? 'white':'black'; // css class switch when is selected or not
    

    // Handler when card is clicked. Adds/removes id from selected
    const clickHandler = (id) => {
        var selected_arr = [];
        if (!props.selected.includes(props.type.id)) {
            selected_arr = [...props.selected];
            selected_arr.push(props.type.id);
        }
        if (props.selected.includes(props.type.id)) {
            selected_arr = props.selected.filter(s => s !== props.type.id);
        }
        props.select(selected_arr);
    }


    // GUI
    return (
            <Col xs="12" md="6" xl="4" >
                <Card
                    
                    className={`disable-select ${!isDisabled? hover + " h-100":'h-100'}`}
                    onMouseEnter={() => setHover('shadow-lg')}
                    onMouseLeave={() => setHover("")}
                    style={{borderRadius: "15px", background: isDisabled? "darkgray":bg, color: textColor, opacity: isDisabled? 0.2:1}}
                    onClick={() => !isDisabled ? clickHandler():null}
                >
                    <Card.Body className="text-start">
                        <Row>
                            <Col xs="9" md="4" xl="9">
                                {props.type.name === "Poolrechnungen" ? (
                                    <FaSwimmingPool size={40} className={isSelected ? 'text-light': isDisabled ? 'text-dark':'text-energo'} />
                                ):
                                props.type.name === "Energielieferant" ? (
                                    <TbTruckDelivery size={40} className={isSelected? 'text-light': isDisabled ? 'text-dark':'text-primary'} />
                                ):
                                props.type.name === "Vorschreibungen" ? (
                                    <TbCoins size={40} className={isSelected? 'text-light': isDisabled ? 'text-dark':'text-warning'} />
                                ):
                                props.type.name === 'Mahnungen' ? (
                                    <RiFileWarningLine size={40} className={isSelected? 'text-light':'text-danger'} />
                                )
                                :null
                                }
                            </Col>
                            <Col xs="3" md="7" xl="3" className="text-end">
                                <div hidden={props.type.count === 0} style={{background: "#EAEEF2", color:"#94A1AE", borderRadius:"25px", textAlign:"center", width: "auto", height: "auto", marginLeft: "auto", padding: "7px"}} >{props.type.count}</div>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs="12" md="12" xl="12">
                                <h5>{props.type.name}</h5>
                                <p className={isSelected? 'text-light':'text-muted'} hidden={props.type.last === ""}>
                                    <BsStopwatch />
                                    &nbsp; Letzte {props.type.name === "Vorschreibungen"? 'Vorschreibung':'Rechnung'} {props.type.last}
                                </p>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
    )
}

export default InvoiceClassCard;